import * as React from 'react'
import {formatPrice, translateCountryName} from "@ui-seeker/utils"

import {HierarchicalTextBlock, LabelCountry, NotAllowedBlock, RetailerBlock} from "@components"
import {Box} from "@mui/material";


export default function countriesColumn() {
    return [{
        name: 'sellerCountry', label: 'Seller Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v)
        }
    },{
        name: 'sellerCountry', label: 'Countries',
        options: {
            headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value, { country }) => {

                const SellerCountryComponent = ({sellerCountry}) => {
                    return <Box>
                        {!!sellerCountry && <LabelCountry country={sellerCountry} label={translateCountryName(sellerCountry)} />}
                        {!sellerCountry && <NotAllowedBlock />}
                    </Box>
                }

                return <Box sx={{ display: 'flex', flexDirection: 'column'}}>
                    <HierarchicalTextBlock title="Retailer Country" titleValue={<LabelCountry country={country} label={translateCountryName(country)} />} />
                    <HierarchicalTextBlock title="Seller Country" titleValue={<SellerCountryComponent sellerCountry={value} />} />
                </Box>
            }
        }
    }]
}